<template>
    <v-container fluid>
        <v-layout class="hide-on-print" row wrap>
            <v-flex xs12>
                <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
                    <h3 class="font-weight-bold">{{ type }} Certification details
                        ({{ certification_detail.status }})</h3>
                </v-flex>
                <v-card>
                    <v-tabs
                        background-color="primary"
                        dark
                        fixed-tabs
                        height="40"
                        v-model="tab">
                        <v-tab href="#certification-detail">
                            <v-icon class="mr-2" size="15">mdi-account-card-details</v-icon>
                            Certification Detail
                        </v-tab>
                        <v-tab href="#history">
                            <v-icon class="mr-2" size="15">mdi-history</v-icon>
                            Certification History
                        </v-tab>

                        <v-tabs-items v-model="tab">
                            <v-tab-item value="certification-detail">
                              <v-flex>
                                <v-alert outlined type="info" v-if="certification_detail.assignment">
                                  <div class="d-flex align-end"
                                       v-if="certification_detail.assignment.assignee_id === user.id">
                                    <div class="mr-2">Please proceed for
                                      {{ certification_detail.assignment.purpose_name }}.
                                    </div>
                                    <div v-if="certification_detail.assignment.remarks">
                                      ({{ certification_detail.assignment.remarks }})
                                    </div>
                                  </div>
                                  <div v-else>
                                    This application has been forwarded to
                                    {{ certification_detail.assignment.assignee_name }} for
                                    {{ certification_detail.assignment.purpose_name }}
                                  </div>
                                </v-alert>
                              </v-flex>
                                <v-card class="pb-4" :loading="loading" flat>
                                    <v-card-text class="mt-4">
                                        <v-layout row wrap class="no-gutters">

                                            <confirmation-header-text
                                                class="pl-2"
                                                icon="mdi-alpha-c-box"
                                                text="Certification Details"/>

                                            <v-flex xs3>
                                                <list-item-detail
                                                    :sub_title="certification_detail.certification_data.country"
                                                    :title="type + ' country'"></list-item-detail>
                                            </v-flex>

                                            <v-flex xs3>
                                                <list-item-detail
                                                    :sub_title="certification_detail.certification_data.office"
                                                    :title="type + ' point'"></list-item-detail>
                                            </v-flex>

                                            <v-flex xs3>
                                                <list-item-detail
                                                    :sub_title="certification_detail.certification_data.date_of_entry"
                                                    :title="'Date of ' +type"></list-item-detail>
                                            </v-flex>

                                            <v-flex v-if="type === 'Arrival'" xs3>
                                                <list-item-detail
                                                    :sub_title="certification_detail.certification_data.purpose_of_visit"
                                                    title="Purpose of visit"></list-item-detail>
                                            </v-flex>


                                            <v-flex xs3 v-if="certification_detail.proof">
                                                <file-list-item-detail
                                                    :src="certification_detail.certification_data.proof"
                                                    :sub_title="'Proof of '+ (type && type.toLowerCase())">
                                                </file-list-item-detail>
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-divider class="my-3"></v-divider>
                                            </v-flex>

                                            <v-flex class="d-flex justify-content-between" xs12>
                                                <confirmation-header-text
                                                    class="pl-2"
                                                    icon="mdi-equal-box"
                                                    text="Visa Details"/>
                                                <v-btn
                                                    @click="viewVisaDetail"
                                                    color="primary"
                                                    dark
                                                    dense
                                                    small
                                                    text>
                                                    View Details
                                                </v-btn>
                                            </v-flex>

                                            <v-flex xs3>
                                                <list-item-detail :sub_title="certification_detail.visa.visa_type"
                                                                  title="Visa Type"></list-item-detail>
                                            </v-flex>
                                            <v-flex xs3>
                                                <list-item-detail :sub_title="certification_detail.visa.visa_number"
                                                                  title="Visa number"></list-item-detail>
                                            </v-flex>
                                            <v-flex xs3>
                                                <list-item-detail :sub_title="certification_detail.visa.submission_no"
                                                                  title="Submission ID"></list-item-detail>
                                            </v-flex>
                                            <v-flex xs3>
                                                <list-item-detail :sub_title="certification_detail.visa.expiry_date"
                                                                  title="Expiry date"></list-item-detail>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-divider class="my-3"></v-divider>
                                            </v-flex>

                                            <v-flex class=" pb-1 d-flex justify-space-between " lg12 md12 sm12>

                                                <confirmation-header-text
                                                    class="pl-2"
                                                    icon="mdi-account"
                                                    text="Personal Details"
                                                />

                                                <v-btn
                                                    @click="viewTravellerData"
                                                    color="primary"
                                                    dark
                                                    dense
                                                    small
                                                    text>
                                                    View Details
                                                </v-btn>
                                            </v-flex>

                                            <v-flex sm3 xs12>
                                                <list-item-detail
                                                    title="Name"
                                                    :sub_title="certification_detail.traveller.name">
                                                </list-item-detail>
                                            </v-flex>

                                            <v-flex sm3 xs12>
                                                <list-item-detail :sub_title="certification_detail.traveller.dob"
                                                                  title="DOB">
                                                </list-item-detail>
                                            </v-flex>

                                            <v-flex sm3 xs12>
                                                <file-list-item-detail :avatar="true"
                                                                       :src="certification_detail.traveller.image"
                                                                       sub_title="User Image">
                                                </file-list-item-detail>
                                            </v-flex>


                                            <v-flex sm3 xs12>
                                                <list-item-detail :sub_title="certification_detail.traveller.gender"
                                                                  title="Gender"></list-item-detail>
                                            </v-flex>

                                            <v-flex sm3 xs12>
                                                <list-item-detail :sub_title="certification_detail.traveller.occupation"
                                                                  title="Occupation">
                                                </list-item-detail>
                                            </v-flex>
                                            <v-flex sm3 xs12>
                                                <list-item-detail title="Email"
                                                                  :sub_title="certification_detail.traveller.email">
                                                </list-item-detail>
                                            </v-flex>

                                            <v-flex sm4 xs12>
                                                <list-item-detail title="Contact Number"
                                                                  :sub_title="certification_detail.traveller.contact_number"
                                                >
                                                </list-item-detail>
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-divider class="my-3"></v-divider>
                                            </v-flex>
                                            <v-flex xs12 v-if="certification_detail.payment_detail" class="my-3">
                                                <payment-detail
                                                    :payment_detail="certification_detail.payment_detail"
                                                    :paid="certification_detail.paid"
                                                ></payment-detail>
                                            </v-flex>
                                            <v-flex xs12 v-else>
                                                <header-text
                                                    class="pl-2"
                                                    text="Payment details"
                                                    icon="mdi-alpha-p-box"
                                                />

                                                <v-layout row wrap class="pl-2">
                                                    <v-flex xs3>
                                                        <list-item-detail
                                                            title="Amount (USD)"
                                                            :sub_title="certification_detail.certification_data && certification_detail.certification_data.cost"
                                                        />
                                                    </v-flex>
                                                    <v-flex xs3
                                                            v-if="certification_detail.payment_data && certification_detail.payment_data.penalty_cost">
                                                        <list-item-detail
                                                            title="Penalty (USD)"
                                                            :sub_title="certification_detail.payment_data.penalty_cost"
                                                        />
                                                    </v-flex>
                                                    <v-flex xs3
                                                            v-if="certification_detail.payment_data && certification_detail.payment_data.penalty_npr">
                                                        <list-item-detail
                                                            title="Penalty (NPR)"
                                                            :sub_title="certification_detail.payment_data.penalty_npr"
                                                        />
                                                    </v-flex>
                                                    <v-flex xs3>
                                                        <list-item-detail
                                                            title="Total (USD)"
                                                            :sub_title="certification_detail.payment_data && certification_detail.payment_data.cost"/>
                                                    </v-flex>
                                                    <v-flex xs3
                                                            v-if="certification_detail.certification_data.exempt_cost > 0">
                                                        <list-item-detail
                                                            title="Exempt cost (USD)"
                                                            :sub_title="certification_detail.certification_data.exempt_cost"
                                                        />
                                                    </v-flex>
                                                    <v-flex xs3 v-if="certification_detail.voucher_number">
                                                        <list-item-detail
                                                            title="Voucher number"
                                                            :sub_title="certification_detail.voucher_number"
                                                        />
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-footer
                                                v-if="certification_detail.can_process"
                                                class="sticky"
                                                color="blue darken-1"
                                                fixed
                                                height="auto"
                                            >
                                                <v-layout
                                                    v-if="!certification_detail.is_verified && !certification_detail.approve_rejected"
                                                    row wrap
                                                >
                                                    <v-spacer/>
                                                    <v-btn
                                                        @click="verify"
                                                        color="blue ml-2"
                                                        class="text-white"
                                                        v-if="certification_detail.can_verify"
                                                    >
                                                        Verify Certification
                                                    </v-btn>
                                                    <v-btn
                                                        @click="reject"
                                                        color="red lighten-1 ml-2"
                                                        class="text-white"
                                                        v-if="certification_detail.can_verify"
                                                    >
                                                        Reject
                                                    </v-btn>
                                                </v-layout>
                                                <v-layout row wrap v-else>
                                                    <v-spacer/>

                                                  <v-btn v-if="showForward" @click="forwardToUser(1)"
                                                         class="text-white" color="blue mr-2">
                                                    Forward
                                                  </v-btn>
                                                  <v-btn @click="verifyTippaniGenerated" class="text-white" color="blue mr-2"
                                                         v-if="showTippaniVerification">
                                                    Verify Tippani
                                                  </v-btn>
                                                  <v-btn @click="approveTippaniGenerated" class="text-white" color="blue mr-2"
                                                         v-if="showTippaniApprove">
                                                    Approve Tippani
                                                  </v-btn>

                                                    <v-btn
                                                        @click="generateTippani"
                                                        class="white--text"
                                                        color="blue"
                                                        v-if="!certification_detail.paid && !certification_detail.tippani_generated && certification_detail.can_verify && !certification_detail.approve_rejected"
                                                    >
                                                        Generate tippani
                                                    </v-btn>

                                                    <v-btn
                                                        @click="print('tippani')"
                                                        class="white--text"
                                                        color="blue"
                                                        v-if="certification_detail.tippani_generated && certification_detail.can_verify && !certification_detail.approve_rejected"
                                                    >
                                                        Print tippani
                                                    </v-btn>

                                                    <v-btn
                                                        @click="exemptCost"
                                                        color="blue ml-2"
                                                        class="text-white"
                                                        v-if="!certification_detail.tippani_generated && !certification_detail.cost_exempted&& certification_detail.can_verify && !certification_detail.approve_rejected"
                                                    >
                                                        Exempt cost
                                                    </v-btn>

                                                    <v-btn
                                                        v-if="!certification_detail.penalty_applied"
                                                        @click="CertificationPenaltyDialog = !CertificationPenaltyDialog"
                                                        class="text-white ml-2"
                                                        color="primary"
                                                    >
                                                        Apply Penalty
                                                    </v-btn>

                                                    <v-btn
                                                        @click="generateVoucher"
                                                        color="blue ml-2"
                                                        class="text-white"
                                                        v-if="certification_detail.tippani_generated && !certification_detail.voucher_generated && certification_detail.can_verify"
                                                        :loading="loading"
                                                    >
                                                        Generate voucher
                                                    </v-btn>
                                                    <v-btn
                                                        @click="print('voucher')"
                                                        color="blue ml-2"
                                                        class="text-white"
                                                        v-if="certification_detail.voucher_generated && certification_detail.can_verify"
                                                    >
                                                        Print voucher
                                                    </v-btn>
                                                    <v-btn
                                                        @click="payManually"
                                                        color="blue ml-2"
                                                        class="text-white"
                                                        v-if="certification_detail.voucher_generated && !certification_detail.paid && certification_detail.can_verify "
                                                    >
                                                        Pay manually
                                                    </v-btn>
                                                    <v-btn
                                                        @click="checkPaymentStatus"
                                                        color="blue ml-2"
                                                        class="text-white"
                                                        v-if="certification_detail.voucher_generated && !certification_detail.paid && certification_detail.extra.malanika_active && certification_detail.can_verify"
                                                    >
                                                        Check payment status
                                                    </v-btn>
                                                    <v-btn
                                                        @click="attachDocument"
                                                        class="white--text"
                                                        color="primary ml-2"
                                                        v-if="showAttachDocuments"
                                                    >
                                                        Attach Document(s)
                                                    </v-btn>
                                                    <v-btn
                                                        @click="reject"
                                                        color="red lighten-1 ml-2"
                                                        class="text-white"
                                                        v-if="certification_detail.paid && !certification_detail.approve_rejected && certification_detail.can_verify"
                                                    >
                                                        Reject
                                                    </v-btn>
                                                    <v-btn
                                                        class="ml-2"
                                                        @click="approve"
                                                        color="primary"
                                                        v-if="(certification_detail.paid && !certification_detail.approve_rejected && certification_detail.can_approve) || (certification_detail.cost_exempted && !certification_detail.approve_rejected && certification_detail.can_approve)"
                                                    >
                                                        Approve
                                                    </v-btn>
                                                </v-layout>
                                            </v-footer>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item value="history">
                                <v-card :loading="loading" flat>
                                  <v-expansion-panels
                                      v-model="panel"
                                      multiple
                                      v-if="certification_detail.assigned_track && certification_detail.assigned_track.length"
                                      class="mb-4"
                                  >
                                  <v-expansion-panel>
                                    <v-expansion-panel-header class="subtitle-2">Forwarded Tracks
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <certification-assignment-history
                                          :history="certification_detail.assigned_track"
                                          :id="certification_detail.id"/>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                  </v-expansion-panels>
                                    <visa-history :history="certification_detail.history" :certification="true"
                                                  :show_load_more="false"/>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>
                </v-card>
            </v-flex>
            <v-flex v-if="!certification_detail.voucher_number" xs12>
                <v-dialog
                    class="hide-on-print"
                    persistent
                    width="800"
                    v-model="tippaniDialog">
                    <v-card class="hide-on-print">
                        <v-toolbar color="blue darken-3" dark v-if="step === 1">
                            <v-toolbar-title>Generate tippani</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text class="pt-4">
                            <div :class="{'hide-on-block':step === 2}">
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <div id="editor"></div>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <div v-if="step === 2">
                                <certification-tippani-print></certification-tippani-print>
                            </div>
                        </v-card-text>
                        <v-card-actions class="mt-8">
                            <v-spacer></v-spacer>
                            <v-btn @click="cancel" color="error">Cancel</v-btn>
                            <v-btn @click="next" color="primary" v-if="step === 1">Next</v-btn>
                            <v-btn @click="save" color="primary" v-if="step === 2">Save</v-btn>
                            <v-btn @click="print('tippani')" color="primary" v-if="step === 2">Print</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-flex>
            <v-flex v-if="certification_detail.paid || certification_detail.cost_exempted" xs12>
                <v-dialog width="700" persistent v-model="approveModal">
                    <v-card>
                        <v-toolbar color="blue darken-3" dark>
                            <v-toolbar-title>Approve {{ type && type.toLowerCase() }} certification</v-toolbar-title>
                        </v-toolbar>

                        <v-card-text class="mt-4">
                            <v-form ref="approveRef">
                                <v-textarea
                                    label="Remarks"
                                    outlined
                                    v-model="approveData.remarks"
                                ></v-textarea>
                                <multiple-file-upload v-model="approveData.files"></multiple-file-upload>

                            </v-form>

                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn @click="cancel" color="red lighten-1" class="white--text">Cancel</v-btn>
                            <v-btn @click="approveCertification" color="primary">Approve</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
        <certification-tippani-print class="show-on-print" v-if="printType ==='tippani'"></certification-tippani-print>
        <manual-payment-dialog v-model="manualDialog"
                               :url="'pay-track-manually/'+certification_detail.submission_no"
                               @paid="getData"></manual-payment-dialog>
        <cost-exemption-dialog v-model="costExemptedDialog"
                               v-if="!certification_detail.tippani_generated && costExemptedDialog"
                               :url="'exempt-cost/'+certification_detail.submission_no"
                               :payment-detail="certification_detail.payment_data"
                               @exempted="exempted"

        ></cost-exemption-dialog>
      <certification-tippani-verification-modal @purposeCompleted="proceedCompletedPurpose"/>
      <certification-forward-dialog v-model="showForwardToUserModal" :purpose="forwardPurpose" :submission-no="certification_detail.id"></certification-forward-dialog>
        <attach-file-dialog
            :url="'certifications/attach-file/'+$store.state.Certification.type +'/'+$route.params.id"
            @attached="getData"
            v-model="attachFileDialog"
        />
        <v-dialog v-model="rejectModal" width="700" persistent>
            <v-card>
                <v-toolbar color="blue darken-3" dark>
                    <v-toolbar-title>Reject {{ type && type.toLowerCase() }} certification</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="mt-4">
                    <v-form ref="rejectRef">
                        <v-textarea
                            :rules="[rules.required]"
                            label="Remarks"
                            outlined
                            v-model="rejectData.remarks"
                        ></v-textarea>
                        <multiple-file-upload v-model="rejectData.files"></multiple-file-upload>
                    </v-form>

                </v-card-text>
                <v-card-actions>
                    <v-spacer/>

                    <v-btn @click="cancel" color="warning">Cancel</v-btn>
                    <v-btn @click="rejectTransfer" color="primary">Reject</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <certification-penalty-dialog
            :id="certification_detail.id"
            v-model="CertificationPenaltyDialog"
            @applied="penaltyCost('penalty')"
        />
        <voucher-content
            class="show-on-print"
            v-if="printType ==='voucher'"
            :data="certification_detail"
        ></voucher-content>
    </v-container>
</template>

<script>
import {
    APPROVE_VISA_CERTIFICATION,
    CHECK_VISA_CERTIFICATION_PAYMENT_STATUS, GENERATE_VOUCHER,
    GET_VISA_CERTIFICATION,
    REJECT_VISA_CERTIFICATION,
    SAVE_VISA_CERTIFICATION_TIPPANI,
    VERIFY_CERTIFICATION
} from "../../../store/action-type";
import ListItemDetail from "../../../components/ListItemDetail";
import HeaderText from "../../../components/HeaderText";
import ConfirmationHeaderText from "../../../components/ConfirmationHeaderText";
import FileListItemDetail from "../../../components/FileListItemDetail";
import DialogFile from "../../../components/FileDisplay";
import FileInput from "../../../components/FileInput";
import MultipleFileUpload from "../../../components/MultipleFileUpload";
import VoucherContent from "../../../components/VoucherContent";
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import {SET_CERTIFICATION_PRINT_CONTENT, SET_CERTIFICATION_TYPE, SET_TIPPANI_VERIFICATION_MODAL, SET_FORWARD_PURPOSE} from "../../../store/mutation-type";
import TransferTippaniPrint from "../../../components/tippani/TransferTippaniPrint";

import {validationMixin} from '../../../mixins/validationMixin'
import CertificationTippaniPrint from "../../../components/tippani/CertificationTippaniPrint";
import PaymentDetail from "../../../components/PaymentDetail";
import ManualPaymentDialog from "../../../components/dialogs/ManualPaymentDialog";
import CostExemptionDialog from "../../../components/dialogs/CostExemptionDialog";

import VisaHistory from "../../../views/visa/visa-request/VisaHistory";
import AttachFileDialog from "@/components/dialogs/AttachFileDialog";
import CertificationPenaltyDialog from "../../../components/dialogs/CertificationPenaltyDialog.vue";
import CertificationForwardDialog from "../../../components/certification/CertificationForwardDialog.vue";
import CertificationAssignmentHistory from "./CertificationAssignmentHistory.vue";
import CertificationTippaniVerificationModal
  from "../../../components/certification/CertificationTippaniVerificationModal.vue";
import {mapActions} from "vuex";

export default {
    name: "CertificationView",
    components: {
      CertificationAssignmentHistory,
        CertificationPenaltyDialog,
        AttachFileDialog,
        ListItemDetail,
        HeaderText,
        DialogFile,
        TransferTippaniPrint,
        FileInput, ConfirmationHeaderText,
        CertificationTippaniPrint, FileListItemDetail,
        MultipleFileUpload,
        PaymentDetail,
        VoucherContent,
        ManualPaymentDialog,
        CostExemptionDialog, VisaHistory,
        CertificationForwardDialog,
      CertificationTippaniVerificationModal
    },
    data() {
        return {
            tab: null,
            tippaniDialog: false,
            step: 1,
            quill: null,
            approveModal: false,
            rejectModal: false,
            printType: null,
            manualDialog: false,
            costExemptedDialog: false,
            attachFileDialog: false,
            CertificationPenaltyDialog: false,
            showForwardToUserModal: false,
            forwardPurpose: null,
        }
    },
    mixins: [validationMixin],
    computed: {
        loading: {
            get() {
                return this.$store.state.AuthUser.loading;
            },
            set(value) {
                this.$store.commit('AuthUser/setLoading', value)
            }
        },
        certification_detail() {
            return this.$store.state.Certification.certificationDetail;
        },
        approveData() {
            return this.$store.state.Certification.approveData;
        },
        rejectData() {
            return this.$store.state.Certification.rejectData;
        },
        type() {
            return this.$store.state.Certification.type;
        },
        // user() {
        //     return this.$store.getters.AuthUser.user;
        // },
        user() {
          return this.$store.state.AuthUser.user;
        },
        showAttachDocuments() {
            const {can_attach_file} = this.certification_detail;

            return can_attach_file;

        },

      showForward() {
        const {automation_enabled, status, assignment, isTippaniVerified} = this.certification_detail;
        if (automation_enabled) {
          return (
              isTippaniVerified &&
              (status !== 'Approved') &&
              (!assignment || assignment.assignee_id === this.user.id)
          )
        }
        return false;
      },

      showTippaniVerification() {
        const {automation_enabled, status, assignment, isTippaniVerified, tippani_generated} = this.certification_detail;
        // console.log(this.user, assignment && assignment.assignee_id === this.user.id && assignment.purpose === 0)
        // console.log('this', this.user,  assignment && assignment.assignee_id === this.user.id && assignment.purpose === 0)
        if (automation_enabled) {
          return (
              tippani_generated &&
              !isTippaniVerified &&
              (status !== 'Approved') &&
              (assignment && assignment.assignee_id === this.user.id && assignment.purpose === 0)
          );
        }
        return false;
      },

      showTippaniApprove() {
        const {automation_enabled, status, assignment, isTippaniVerified, tippani_generated} = this.certification_detail;
        if (automation_enabled) {
          return (
              tippani_generated &&
              isTippaniVerified &&
              (status !== 'Approved') &&
              (assignment && assignment.assignee_id === this.user.id && assignment.purpose === 2)
          );
        }
        return false;
      },
    },
    methods: {
        attachDocument() {
            this.attachFileDialog = true;
        },
        exemptCost() {
            this.costExemptedDialog = true;
        },
        viewTravellerData() {
            window.open('/system/travellers-history/view/' + this.certification_detail.traveller.id)
        },
        viewVisaDetail() {
            window.open('/system/visa-requests/view/' + this.certification_detail.visa.submission_no, '_blank')
        },
        next() {
            this.$store.commit(SET_CERTIFICATION_PRINT_CONTENT, this.quill.root.innerHTML);
            this.step = 2;
        },
        payManually() {
            this.manualDialog = true;
        },
        print(type) {
            this.printType = type;
            setTimeout(() => {
                window.print()
            }, 200)
        },
        exempted(data) {
            this.certification_detail.cost_exempted = true;
            this.certification_detail.certification_data.cost = this.certification_detail.certification_data.cost - data;
            this.certification_detail.certification_data.exempt_cost = data;
            this.certification_detail.penalty_cost.penalty_amount = data;

        },
        approve() {
            this.approveModal = true;
        },
        approveCertification() {
            if (this.$refs.approveRef.validate()) {
                this.$store.dispatch(APPROVE_VISA_CERTIFICATION).then(() => {
                    this.approveModal = false;
                    this.$store.commit('Notification/showSuccess', 'Certification  has been approved');
                    this.$store.dispatch(GET_VISA_CERTIFICATION, this.$route.params.id);
                }).catch((err) => {
                    this.$store.commit('Notification/showError', 'Something went wrong')
                })
            }
        },
        rejectTransfer() {
            if (this.$refs.rejectRef.validate()) {
                this.$store.dispatch(REJECT_VISA_CERTIFICATION).then((res) => {
                    this.rejectModal = false;
                    this.$store.commit('Notification/showSuccess', 'Transfer has been rejected');
                    this.$store.dispatch(GET_VISA_CERTIFICATION, this.$route.params.id);
                }).catch((err) => {
                    this.$store.commit('Notification/showError', 'Something went wrong')
                })
            }
        },
        reject() {
            this.rejectModal = true;
        },
        checkPaymentStatus() {
            this.$store.dispatch(CHECK_VISA_CERTIFICATION_PAYMENT_STATUS, this.certification_detail.submission_no).then((res) => {
                this.$store.commit('Notification/showSuccess', res.data.message);
            }).catch((err) => {
                this.$store.commit('Notification/showError', err.response.data.message)
            })
        },
        generateVoucher() {
            this.loading = true
            this.$store.dispatch(GENERATE_VOUCHER).then((res) => {
                this.$store.commit('Notification/showSuccess', res.message);
                this.$store.dispatch(GET_VISA_CERTIFICATION, this.$route.params.id);
            }).catch(err => {
                this.$store.commit('Notification/showError', err.response.data.message);
            }).finally(() => {
                this.loading = false;
            })
        },
        async save() {
            await this.$dialog.confirm({
                text: "Are you sure want to save tippani ? (Tippani once save cannot be reverted )",
                actions: {
                    false: "No",
                    true: {
                        text: "Yes",
                        handle: () => {
                            this.$store.dispatch(SAVE_VISA_CERTIFICATION_TIPPANI, this.quill.root.innerHTML).then((res) => {
                                this.$store.commit('Notification/showSuccess', 'Tippani has been generated');
                                if (this.certification_detail.automation_enabled) {
                                  this.showForwardToUserModal = true;
                                }
                                this.certification_detail.tippani_generated = true;
                                this.tippaniDialog = false;
                                this.$store.dispatch(GET_VISA_CERTIFICATION, this.$route.params.id);
                            }).catch((err) => {
                                this.$store.commit('Notification/showError', err.response.data.message)
                            })
                        }
                    }
                }
            });
        },
        cancel() {
            if (this.step === 1) {
                this.tippaniDialog = false;
            } else {
                this.step = 1;
            }
            this.approveModal = false;
            this.rejectModal = false;

        },
        paid() {
            this.$store.dispatch(GET_VISA_CERTIFICATION, this.$route.params.id);
        },
        generateTippani() {
            let tippani = this.certification_detail.tippani;
            this.tippaniDialog = true;
            let content = tippani;
            content = content.replace('@cost', this.certification_detail.certification_data.cost);
            content = content.replace('@entry_date', this.certification_detail.certification_data.date_of_entry);
            content = content.replace('@entry_point', this.certification_detail.certification_data.office);
            setTimeout(() => {
                if (!this.quill)
                    this.quill = new Quill('#editor', {
                        theme: 'snow',
                        modules: {
                            toolbar: [
                                [{header: [1, 2, false]}],
                                ['bold', 'italic', 'underline'],
                            ],
                        },
                    });
                this.quill.root.innerHTML = content;
            }, 100);

        },
        async forwardToUser(type) {
          this.forwardPurpose = type ? type : 0;
          this.showForwardToUserModal = true;
        },
        verify() {
            this.$store.dispatch(VERIFY_CERTIFICATION)
                .then((res) => {
                    this.$store.commit('Notification/showSuccess', res.data.message);
                    this.$store.dispatch(GET_VISA_CERTIFICATION, this.$route.params.id);
                })
                .catch((err) => {
                    this.$store.commit('Notification/showError', err.response.data.message)
                })
        },
        getData() {
            this.$store.dispatch(GET_VISA_CERTIFICATION, this.$route.params.id);
        },

        penaltyCost(data = null) {
            this.$store.dispatch(GET_VISA_CERTIFICATION, this.$route.params.id);
        },

      verifyTippaniGenerated() {
        this.$store.commit(SET_FORWARD_PURPOSE, 'verify-tippani')
        this.$store.commit(SET_TIPPANI_VERIFICATION_MODAL, true);
      },
      approveTippaniGenerated() {
        this.$store.commit(SET_FORWARD_PURPOSE, 'approve-tippani')
        this.$store.commit(SET_TIPPANI_VERIFICATION_MODAL, true);
      },
      proceedCompletedPurpose(data = null) {
        console.log('daata', data)
        if (this.certification_detail.automation_enabled) {
          if (data && data === 'verify-tippani') {
            this.forwardToUser(2)
          }
        }
      },
    },
    mounted() {
        let type = this.$route.params.type;
        this.$store.commit(SET_CERTIFICATION_TYPE, type);
        this.$store.dispatch(GET_VISA_CERTIFICATION, this.$route.params.id);
    }
}
</script>
